import { Paper, styled } from '@mui/material';

interface StyledPaperProps {
  length: number;
}

const StyledTablePaper = styled(Paper)<StyledPaperProps>(
  ({ theme, length }) => ({
    borderTopLeftRadius: '1.25rem',
    borderTopRightRadius: '1.25rem',
    padding: '1.875rem',
    height: length > 0 ? undefined : '100%',
    width: '97%',
    maxHeight: length > 0 ? undefined : '95vh',
  }),
);

export default StyledTablePaper;
